<template>
  <div>
    <md-dialog :md-active.sync="showDialog">
      <md-dialog-title v-if="mode==='create'">Create CCR Log Data</md-dialog-title>
      <md-dialog-title v-if="mode==='update'">Update CCR Log Data</md-dialog-title>
      <md-progress-bar  id="pb" style="display:none" md-mode="indeterminate"/>           

      <md-dialog-content>

        <form novalidate @submit.prevent="doSave">

        <div id="masterData">
          <!--
          <md-field :class="getValidationClass('dataForm.group')">
            <label>Group</label>
            <md-input v-model="dataForm.group" disabled/> -->
            <!--<span class="md-error" v-if="!$v.dataForm.group.required">Group is required</span>-->
          <!-- </md-field>-->
          
          <!--
          <md-field :class="getValidationClass('dataForm.tagId')">
            <label>Tag Id</label>
            <md-input v-model="dataForm.tagId"/>
            <span class="md-error" v-if="!$v.dataForm.tagId.required">Tag Id is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.tagName')">
            <label>Tag Name</label>
            <md-input v-model="dataForm.tagName"/>
            <span class="md-error" v-if="!$v.dataForm.tagName.required">Tag Name is required</span>
          </md-field>
          -->
          <!--
          <div>
              <md-field>
                <label>Transloading Yard</label>
                <md-input v-model="dataForm.transYard" disabled />
              </md-field>

          </div>
          -->
          
          <div>
            <!-- 2nd col -->
            <div class = "inputBoxInbound selectfield" >
              <auto-complete-master-data-select
                                                group="REC_WINDOW"
                                                label="Yard"
                                                :init-value="dataForm.yard"
                                                :watchValueId="dataForm.yard"
                                                :on-item-changed="handleWindowsChanged"
                                                >
            </auto-complete-master-data-select>
            </div>
          
            
          </div>

          <div>
            <div class = "inputBoxInbound selectfield secondcol" >
              <auto-complete-master-data-select
                                                group="CCR_GATETYPE"
                                                label="Gate Type"
                                                display-type="nameOnly"
                                                :init-value="dataForm.gateType"
                                                :watchValueId="dataForm.gateType"
                                                :on-item-changed="handleGateTypeChanged"
                                                >
            </auto-complete-master-data-select>
            </div>
          </div>
          
          <div class="selectfield">
          <md-field :class = "getValidationClass('dataForm.gateNo')">
            <label>Gate No.</label>
            <md-input v-model="dataForm.gateNo"/>
          </md-field>
          </div>

          <div>
            <div class = "inputBoxInbound selectfield secondcol" >
              <auto-complete-master-data-select
                                                group="CCR_STATUSTYPE"
                                                label="Status Type"
                                                display-type="nameOnly"
                                                :init-value="dataForm.statusType"
                                                :watchValueId="dataForm.statusType"
                                                :on-item-changed="handleStatusTypeChanged"
                                                >
            </auto-complete-master-data-select>
            </div>
          </div>

          <div class = "selectfield">
                <md-field>
                <label for="logDateTime">Log Date Time</label>
                <md-input name="logDateTime"
                        id="logDateTime"
                        autocomplete="new-password"
                        v-model="dataForm.logDateTime"
                        placeholder="Format: YYYY-MM-DDTHH:MM:SS"
                />
                <span class="md-error" v-if="!$v.dataForm.logDateTime.add">
                   Log date time format is invalid!
                 <br/></span>  
                </md-field>
          </div>

          <div class="selectfield secondcol">
            <md-field :class="getValidationClass('dataForm.plateNo')">
              <label>Plate No.</label>
              <md-input v-model="dataForm.plateNo"/>
            </md-field>
          </div>

          <md-field :class="getValidationClass('dataForm.plateImage')">
            <label>Plate Image</label>
            <md-input v-model="dataForm.plateImage"/>
          </md-field>

          <div class="selectfield"> 
            <md-field :class="getValidationClass('dataForm.containerNo')">
              <label>Container No.</label>
              <md-input v-model="dataForm.containerNo"/>
            </md-field>
          </div>

          <div>
            <div class = "inputBoxInbound selectfield secondcol" >
              <auto-complete-master-data-select
                                                group="CCR_CNTRTYPE"
                                                label="Container Type"
                                                :init-value="dataForm.containerType"
                                                :watchValueId="dataForm.containerType"
                                                :on-item-changed="handleContainerTypeChanged"
                                                >
            </auto-complete-master-data-select>
            </div>
          </div>

          <md-field :class="getValidationClass('dataForm.containerImage')">
            <label>Container Image</label>
            <md-input v-model="dataForm.containerImage"/>
          </md-field>

          <div class="selectfield">
            <md-field :class="getValidationClass('dataForm.chassisNo')">
              <label>Chassis No.</label>
              <md-input v-model="dataForm.chassisNo"/>
            </md-field>
          </div>

          <div class="selectfield secondcol">
            <md-field :class="getValidationClass('dataForm.scaleWeight')">
              <label>Scale Weight</label>
              <md-input v-model="dataForm.scaleWeight"/>
            </md-field>
          </div>

          <md-field :class="getValidationClass('dataForm.chassisImage')">
            <label>Chassis Image</label>
            <md-input v-model="dataForm.chassisImage"/>
          </md-field>

          <div class="selectfield">
            <md-field :class="getValidationClass('dataForm.inboundShipment')">
              <label>Inbound Shipment Number</label>
              <md-input v-model="dataForm.inboundShipment"/>
            </md-field>
          </div>

          <div class="selectfield secondcol">
            <md-field :class="getValidationClass('dataForm.seqNo')">
              <label>Seq Number</label>
              <md-input v-model="dataForm.seqNo"/>
            </md-field>
          </div>


        </div>

          <calling-api type="bar" path="/api/w/ccr/updateCCRLog">

            <md-dialog-actions>
              <md-button class="md-primary" @click="closeDialog();showDialog = false">Close</md-button>
              <md-button type="submit" class="md-primary">Save</md-button>
            </md-dialog-actions>

          </calling-api>


        </form>

      </md-dialog-content>
    </md-dialog>
  </div>
</template>
<style scoped>
  form {
    min-width: 640px;
    margin: 24px;
  }
  .selectfield {
    width: 250px;
  }
  .secondcol {
    margin-top: -55px;
    margin-left: 350px
  }
</style>
<script>
  import { validationMixin } from 'vuelidate';
  import { mapGetters } from 'vuex';
  import { required, } from 'vuelidate/lib/validators';
  import DatePicker from './DatePicker.vue';
  import moment from 'moment';
  //import api from '../api';
  import { newAPIPost } from '../api/index.js';

  const getInitialDataForm = () => ({
    // group: "T_APP_MASTER",
    // tagId: null,
    // tagName: null,
    // active: true,
    // recWindow: null,
    // recWindowDesc: null,
    // from: null,
    // to: null,
    // transYard: "1010001",
    // weekDay: null,
    // weekDayDesc: null,
    // occurence: 1,
    // extTrucker: null,
    // extTruckerId: null,
    // dockType: null
    logId: null,
    yard: null,
    gateType: null,
    gateTypeDesc: null,
    gateNo: null,
    statusType: null,
    statusTypeDesc: null,
    logDateTime: null,
    plateNo: null,
    plateImage: null,
    containerNo: null,
    containerType: null,
    containerImage: null,
    chassisNo: null,
    chassisImage: null,
    scaleWeight: null,
    processType: null,
    inboundShipment: null,
    seqNo: null,
  });

  const getInitialSaveData = () => ({
    logId: null,
    yard: null,
    gateType: null,
    gateNo: null,
    statusType: null,
    logDateTime: null,
    plateNo: null,
    plateImage: null,
    containerNo: null,
    containerType: null,
    containerImage: null,
    chassisNo: null,
    chassisImage: null,
    scaleWeight: null,
    processType: null,
    inboundShipment: null,
    seqNo: null,
  });

  const getInitialRequestData = () => ({
    logId: null,
    yard: null,
    gateType: null,
    gateNo: null,
    statusType: null,
    logDateTime: null,
    plateNo: null,
    plateImage: null,
    containerNo: null,
    containerType: null,
    containerImage: null,
    chassisNo: null,
    chassisImage: null,
    scaleWeight: null,
    processType: null,
    inboundShipment: null,
    seqNo: null,
  });

  export default {
  components: { DatePicker },
    mixins: [validationMixin],
    props: {
      mode: String,
      onUpdate: Function,
    },
    data: () => ({
      showDialog: false,
      stores: [],
      dispatchers: [],
      updatelog: [],
      tempGateType: null,
      tempStatusType: null,
      dataForm: getInitialDataForm(),
      saveData: getInitialSaveData(),
      requestData: getInitialRequestData(),
    }),
    computed: {
      ...mapGetters([
        'getMasterDataByGroup',
        'getMasterDataName',
        'getSaleOfficeMasterData',
        'getPermission'
      ]),
      getDispatcherInitValue() {
        if (this.mode === 'create') {
          return null;
        }
        return `${this.dataForm.dispatcherName} (${this.dataForm.dispatcherId})`;
      },
      getSpecialStatusInitValue() {
        if (this.mode === 'create') {
          return null;
        }
        return `${this.dataForm.statusName} (${this.dataForm.statusId})`;
      },
    },
    watch: {},
    validations: {
      dataForm: {
        yard: {
          required,
        },
        logDateTime:{
            add : (value) => {
              //var hour = value.toString().substr(1,value.indexOf(":"));
              if (value != null) {
              if (value.indexOf(":") > -1 && value.length >= 1) {
                 console.log("hour: " + value.substr(0,value.indexOf(":")));
                 console.log("min: " + value.substr(value.indexOf(":")+1))
                 var hour = value.substr(0,value.indexOf(":"));
                 var min = value.substr(value.indexOf(":")+1);
                 if (hour.length == 1) hour = "0" + hour;
                 if (min.length == 1) min = "0" + min;
              }
              var setDate = "2021-04-01T" + hour + ":" + min + ":00"; 
              const res = moment(setDate).toDate();
              console.log("appt time: " + value + " setDate: " + setDate + " rec: " + res);
              return res != 'Invalid Date';
              }
              else 
                return "";
            }
        },
      },
    },
    methods: {
      //openDialog(existingData) {
      openDialog(updateItem) {         
        this.dataForm = getInitialDataForm();
        this.$v.dataForm.$reset();
        console.log("mode: " + this.mode);
        if (this.mode === "update")
        {
          if (updateItem)
          {
            console.log("item - logId: " + updateItem.logId);
            console.log("item - yard: " + updateItem.yard);
            console.log("item - gateType: " + updateItem.gateType);
            console.log("item - gateNo: " + updateItem.gateNo);
            console.log("item - statusType: " + updateItem.statusType);
            console.log("item - logDateTime: " + updateItem.logDateTime);
            console.log("item - plateNo: " + updateItem.plateNo);
            console.log("item - plateImage: " + updateItem.plateImage);
            console.log("item - containerNo: " + updateItem.containerNo);
            console.log("item - containerType: " + updateItem.containerType);
            console.log("item - containerImage: " + updateItem.containerImage);
            console.log("item - chassisNo: " + updateItem.chassisNo);
            console.log("item - chassisImage: " + updateItem.chassisImage);
            console.log("item - scaleWeight: " + updateItem.scaleWeight);
            console.log("item - inboundShipment: " + updateItem.inboundShipment);
            console.log("item - seqNo: " + updateItem.seqNo);

            this.dataForm.logId = updateItem.logId;
            this.dataForm.yard = updateItem.yard;
            //this.dataForm.gateType = updateItem.gateType;
            //this.handleGateTypeChanged(this.updateItem.gateType);
            //this.dataForm.gateType = updateItem.gateType;
            //this.dataForm.gateTypeDesc = this.getMasterDataName("CCR_GATETYPE",updateItem.gateType);
            this.tempGateType = updateItem.gateType;
            this.dataForm.gateTypeDesc = this.getMasterDataName("CCR_GATETYPE",updateItem.gateType);
            this.dataForm.gateType = this.dataForm.gateTypeDesc; 
            this.dataForm.gateNo = updateItem.gateNo;
            this.tempStatusType = updateItem.statusType;
            this.dataForm.statusTypeDesc = this.getMasterDataName("CCR_STATUSTYPE",updateItem.statusType);
            this.dataForm.statusType = this.dataForm.statusTypeDesc;
            this.dataForm.logDateTime = updateItem.logDateTime;
            this.dataForm.plateNo = updateItem.plateNo;
            this.dataForm.plateImage = updateItem.plateImage;
            this.dataForm.containerNo = updateItem.containerNo;
            this.dataForm.containerType = updateItem.containerType;
            this.dataForm.containerImage = updateItem.containerImage;
            this.dataForm.chassisNo = updateItem.chassisNo;
            this.dataForm.chassisImage = updateItem.chassisImage;
            this.dataForm.scaleWeight = updateItem.scaleWeight;
            this.dataForm.processType = "X";
            this.dataForm.inboundShipment = updateItem.inboundShipment;
            this.dataForm.seqNo = updateItem.seqNo;
          }
        }
        this.showDialog = true;
      },
      closeDialog(){
      },
      getValidationClass(fieldName) {
        const field = _(this.$v)
          .lookup(fieldName);
        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty,
          };
        }
        return {};
      },
      handleWindowsChanged(id) {
        this.dataForm.yard = id;
      },
      handleGateTypeChanged(id) {
        this.dataForm.gateType = id;
      },
      handleStatusTypeChanged(id) {
        this.dataForm.statusType = id;
      },
      handleContainerTypeChanged(id) {
        this.dataForm.containerType = id;
      },



      showinternalData() {
          console.log("logId: " + this.dataForm.logId);
          console.log("yard: " + this.dataForm.yard);
          console.log("gateType: " + this.dataForm.gateType);
          console.log("gateNo: " + this.dataForm.gateNo);
          console.log("statusType: " + this.dataForm.statusType);
          console.log("logDateTime: " + this.dataForm.logDateTime);
          console.log("plateNo: " + this.dataForm.plateNo);
          console.log("plateImage: " + this.dataForm.plateImage);
          console.log("containerNo: " + this.dataForm.containerNo);
          console.log("containerType: " + this.dataForm.containerType);
          console.log("containerImage: " + this.dataForm.containerImage);
          console.log("chassisNo: " + this.dataForm.chassisNo);
          console.log("chassisImage: " + this.dataForm.chassisImage);
          console.log("scaleWeight: " + this.dataForm.scaleWeight);
          console.log("inboundShipment: " + this.dataForm.inboundShipment);
          console.log("seqNo: " + this.dataForm.seqNo);
      },

      showSaveData() {
          console.log("logId: " + this.saveData.logId);
          console.log("yard: " + this.saveData.yard);
          console.log("gateType: " + this.saveData.gateType);
          console.log("gateNo: " + this.saveData.gateNo);
          console.log("statusType: " + this.saveData.statusType);
          console.log("logDateTime: " + this.saveData.logDateTime);
          console.log("plateNo: " + this.saveData.plateNo);
          console.log("plateImage: " + this.saveData.plateImage);
          console.log("containerNo: " + this.saveData.containerNo);
          console.log("containerType: " + this.saveData.containerType);
          console.log("containerImage: " + this.saveData.containerImage);
          console.log("chassisNo: " + this.saveData.chassisNo);
          console.log("chassisImage: " + this.saveData.chassisImage);
          console.log("scaleWeight: " + this.saveData.scaleWeight);
          console.log("inboundShipment: " + this.saveData.inboundShipment);
          console.log("seqNo: " + this.saveData.seqNo);
      },

      setupSaveData() {
          var logDateTime = this.dataForm.logDateTime;
          console.log("logDateTime: " + logDateTime);
          var hour = "";
          var min = "";
          this.saveData.yard = this.dataForm.yard;
          this.saveData.gateType = this.dataForm.gateType;
          this.saveData.statusType = this.dataForm.statusType;
          this.saveData.plateNo = this.dataForm.plateNo;
          this.saveData.plateImage = this.dataForm.plateImage;
          this.saveData.containerNo = this.dataForm.containerNo;
          this.saveData.containerType = this.dataForm.containerType;
          this.saveData.containerImage = this.dataForm.containerImage;
          this.saveData.chassisNo = this.dataForm.chassisNo;
          this.saveData.chassisImage = this.dataForm.chassisImage;
          this.saveData.scaleWeight = this.dataForm.scaleWeight;
          this.saveData.inboundShipment = this.dataForm.inboundShipment;
          this.saveData.seqNo = this.dataForm.seqNo;
      },
 
      async doSave() {
        this.$v.dataForm.$touch();

        this.showinternalData();
        this.setupSaveData();
        this.showSaveData();
        
        /*
        if (this.$v.dataForm.$invalid) {
          console.log("data invalid");
          return;
        }
        */

        //this.$store
        //  .dispatch(
        //    "updateMasterDataGroup",
        //    this.dataForm.group,
        //  ).then( () => {console.log("save Master Data Group" + this.dataForm.group);});

        console.log("save data");
        // this.$store
        //   .dispatch(
        //     "updateMasterData",
        //     this.saveData,
        //   )
        document.getElementById("pb").style.display = "";
        this.requestData.logId = this.dataForm.logId;
        this.requestData.yard = this.dataForm.yard;
        console.log("gateType: " + this.dataForm.gateType);
        console.log("gateTypeDesc: " + this.dataForm.gateTypeDesc);
        console.log("tmpgatetype: " + this.tempGateType);
        if (this.dataForm.gateTypeDesc != this.dataForm.gateType)
           this.requestData.gateType = this.dataForm.gateType;
        else
           this.requestData.gateType = this.tempGateType;   
        this.requestData.gateNo = this.dataForm.gateNo;
        if (this.dataForm.statusTypeDesc != this.dataForm.statusType)
           this.requestData.statusType = this.dataForm.statusType;
        else
           this.requestData.statusType = this.tempStatusType;   
        this.requestData.logDateTime = this.dataForm.logDateTime;
        this.requestData.plateNo = this.dataForm.plateNo;
        this.requestData.plateImage = this.dataForm.plateImage;
        this.requestData.containerNo = this.dataForm.containerNo;
        this.requestData.containerType = this.dataForm.containerType;
        this.requestData.containerImage = this.dataForm.containerImage;
        this.requestData.chassisNo = this.dataForm.chassisNo;
        this.requestData.chassisImage = this.dataForm.chassisImage;
        this.requestData.logId = this.dataForm.logId;
        this.requestData.scaleWeight = this.dataForm.scaleWeight;
        this.requestData.processType = this.dataForm.processType;
        this.requestData.inboundShipment = this.dataForm.inboundShipment;
        this.requestData.seqNo = this.dataForm.seqNo;

          this.updatelog.logId = this.requestData.logId;
          this.updatelog.yard = this.requestData.yard;
          this.updatelog.gateNo = this.requestData.gateNo;
          this.updatelog.gateType = this.requestData.gateType;
          this.updatelog.statusType = this.requestData.statusType;
          this.updatelog.logDateTime = this.requestData.logDateTime;
          this.updatelog.plateNo = this.requestData.plateNo;
          this.updatelog.plateImage = this.requestData.plateImage;
          this.updatelog.containerNo = this.requestData.containerNo;
          this.updatelog.containerType = this.requestData.containerType;
          this.updatelog.containerImage = this.requestData.containerImage;
          this.updatelog.chassisNo = this.requestData.chassisNo;
          this.updatelog.chassisImage = this.requestData.chassisImage;
          this.updatelog.scaleWeight = this.requestData.scaleWeight;
          this.updatelog.inboundShipment = this.requestData.inboundShipment;
          this.updatelog.seqNo = this.requestData.seqNo;
          //this.updatelog.status = this.requestData.logStatus;
        

        //await api.post('/api/w/ccr/data/updateCCRLog', this.requestData)
        await newAPIPost('/api/w/ccr/data/updateCCRLog', this.requestData)
          .then(() => {
            console.log("save master data info");
            this.onUpdate(this.updatelog);
            console.log("pb: " + document.getElementById("pb"));
            document.getElementById("pb").style.display = "none";
            this.showDialog = false;
            //this.onUpdate();
          });
      
      },
    },
  };
</script>
